import React from 'react';
import { FullPageLoader } from 'shared/components/loading';
import { useGetMenuCustomization } from '../data-access';
import { ProductCardsForm } from './product-cards-form';

export function ProductCards(): JSX.Element | null {
  const { data, loading } = useGetMenuCustomization();

  if (loading) {
    return <FullPageLoader />;
  }

  if (data) {
    return <ProductCardsForm data={data} />;
  }

  console.error(new Error(`missing web customization data`));
  return null;
}
